import { render, staticRenderFns } from "./new-user-login.vue?vue&type=template&id=4f5f092c&"
import script from "./new-user-login.vue?vue&type=script&lang=ts&"
export * from "./new-user-login.vue?vue&type=script&lang=ts&"
import style0 from "./new-user-login.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports